


























import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import TrainResultKC from '@/trials/views/trials/train/result/TrainResultKC.vue';
import TrainResultParams from '@/trials/views/trials/train/result/TrainResultParams.vue';

@Component({ components: { TrainResultKC, TrainResultParams } })
export default class TrainResultAll extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private currentPage: string = 'All';
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // アクティブコンテンツ
    private get currentContent() {
        return sessionModule.getCurrentRouterViewTrainResultAll;
    }
    private get isAll(): boolean {
        return this.currentContent === SC.Path.TRAIN_RESULT_ALL_KC;
    }
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    /* Clickメソッド(コンテンツ切替) 
        ------------------------------*/
    // 全体
    private toAll() {
        sessionModule.SET_ROUTE_TRAIN_RESULT_ALL(SC.Path.TRAIN_RESULT_ALL_KC);
    }

    // パラメータ
    private toParams() {
        sessionModule.SET_ROUTE_TRAIN_RESULT_ALL(SC.Path.TRAIN_RESULT_ALL_PARAMS);
    }
}
